// languages/chineseSimplified.js
export const chineseSimplified = {
  name: "中文",
  interface: {
    welcome: "欢迎",
    chooseLanguage: "选择语言",
    continue: "继续",
    backToMap: "返回地图",
    achievement: "成就",
    viewInAR: "在AR中查看",
    menu: {
      menu: "菜单",
      home: "首页",
      language: "语言",
      achievement: "成就",
      unsuiExperience: "云水体验",
      feedback: "反馈",
    },
    buyScreen: {
      clickToBuy: "点击购买寺庙",
      templeExperience: "的特别体验！",
      description1: "通过音频导览聆听关",
      description2: "于寺庙的迷人故事，",
      description3: "并享受神奇的AR体验！",
      buy: "购买",
    },
    gift: {
      congratulations: "恭喜！",
      yourGift: "你的礼物",
      giftTitle: "The Supreme Truth",
      giftText: "Check out this amazing gift!",
    },
  },
};
